// extracted by mini-css-extract-plugin
export default {"container":"ChangeStatus_container__7qnZd","selectWrapper":"ChangeStatus_selectWrapper__RXNdR","text":"ChangeStatus_text__E+wT0","actionBtns":"ChangeStatus_actionBtns__5Nqte"};